import { Box } from '@chakra-ui/react';
import { useRef } from 'react';

/**
 * Thin drag handle docked on the top edge of a bottom-docked panel (command
 * line). Dragging up/down reports the new height through onResize; the caller
 * owns clamping and persistence. `currentHeight` is the panel's live height so
 * the drag delta starts from where the panel actually is.
 */
export function PanelResizeHandle({ currentHeight, onResize }: { currentHeight: number; onResize: (height: number) => void }) {
    const dragStart = useRef<{ y: number; height: number } | null>(null);

    const handleMouseMove = (e: React.MouseEvent) => {
        if (!dragStart.current) return;
        const MIN_HEIGHT = 80;
        const MAX_HEIGHT = Math.round(window.innerHeight * 0.7);
        const next = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, dragStart.current.height + (dragStart.current.y - e.clientY)));
        onResize(next);
    };

    const endDrag = () => { dragStart.current = null; };

    return (
        <Box
            position="absolute"
            top="-3px"
            left={0}
            right={0}
            h="6px"
            cursor="ns-resize"
            zIndex={20}
            _hover={{ bg: 'whiteAlpha.200' }}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dragStart.current = { y: e.clientY, height: currentHeight };
            }}
            onMouseMove={handleMouseMove}
            onMouseUp={endDrag}
            onMouseLeave={endDrag}
        />
    );
}
